module.exports = __webpack_public_path__ + "static/media/fb8525d9-180b-46cb-8e6c-990847a42934_1.14e1e99b3bee52b8ff0b33ea3529eff4.745182ee.jpeg";